import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

/**
 * Returns a human-readable error string from an axios error.
 * Handles FastAPI's `{detail: {code, message, ...}}` and `{detail: "string"}` shapes.
 */
export function normalizeApiError(err, fallback = "Si è verificato un errore") {
  if (isServiceDown(err)) return SERVICE_DOWN_MSG;
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d === "object") {
    if (d.code === "INSUFFICIENT_CREDITS") {
      // Handled globally by the modal — just return a short string.
      return d.message || `Crediti insufficienti: servono ${d.required}, disponibili ${d.available}.`;
    }
    if (d.code === "WORD_LIMIT_REACHED" || d.code === "WORD_LIMIT_INSUFFICIENT") {
      return d.message || `Parole esaurite: ${d.used}/${d.monthly}.`;
    }
    return d.message || JSON.stringify(d);
  }
  return err?.message || fallback;
}

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  try { cfg.headers["X-BF-Page"] = window.location.pathname; } catch {}
  return cfg;
});

export const SERVICE_DOWN_MSG = "Servizio momentaneamente non disponibile, riprova tra qualche minuto.";
// Network failure or gateway/Cloudflare 5xx (502-504, 520-527) = backend unreachable
export const isServiceDown = (e) => {
  if (!e || e.code === "ERR_CANCELED") return false;
  const st = e.response?.status;
  if (!e.response) return true;
  return [502, 503, 504].includes(st) || (st >= 520 && st <= 527);
};

api.interceptors.response.use(
  (r) => {
    // Notify UI widgets when any AI call succeeds so credits balance refreshes.
    try {
      const url = r?.config?.url || "";
      if (/^\/(ai|images|credits|billing)/.test(url) && (r.config.method || "get").toLowerCase() !== "get") {
        window.dispatchEvent(new CustomEvent("bf:credits-updated"));
      }
    } catch (_) {}
    return r;
  },
  (e) => {
    const status = e?.response?.status;
    if (isServiceDown(e)) {
      try { window.dispatchEvent(new CustomEvent("bf:service-down")); } catch (_) {}
    }
    if (status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register") && path !== "/") {
        localStorage.removeItem("bf_token");
        localStorage.removeItem("bf_user");
        window.location.href = "/login";
      }
    }
    if (status === 402) {
      const detail = e?.response?.data?.detail || {};
      // Dispatch a global event so a mounted modal can react from anywhere.
      try {
        window.dispatchEvent(new CustomEvent("bf:insufficient-credits", { detail }));
      } catch (_) {}
    }
    return Promise.reject(e);
  }
);

export default api;
